import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { campaignData } from "../../store/action";
import SelectOpt from "../Multiselect/Multiselect";
import Button from "../Button/Button";
import { t } from "i18next";
import "./Orderrow.scss";
import { Details } from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const OrderRow = ({
  data,
  index,
  arrSum,
  remove,
  removeVar,
  setBool,
  Sample,
}) => {
  const campaign = useSelector((state) => state.campaign.campaign);
  const [col, setcol] = useState("");
  const [colVar, setcolVar] = useState("");
  const [shirtsdata3, setshirtdata3] = useState("");
  const [shirtsdata4, setshirtdata4] = useState("");

  const [coldata, setcoldata] = useState("");
  const [size, setsize] = useState("");
  const [sizeVar, setsizeVar] = useState("");

  const [sizedata, setsizedata] = useState("");
  const [color, setColor] = useState("");
  const dispatch = useDispatch();
  let tempCampaign = [...campaign];
  // useEffect(() => {
  //   if (data.color) {
  //     setColor(data.color);
  //   } else if (data.hello.color) {
  //     setColor(data.hello.color);
  //   }
  // }, [data]);
  const Increament = (data) => {
    tempCampaign[index].quantity += 1;
    setredux();
  };

  const Decreament = (data) => {
    tempCampaign[index].quantity -= 1;
    setredux();
    if (Sample) {
      setBool();
    }
  };

  const DecreamentVar = (data, ind) => {
    tempCampaign[index].variation[ind].quantity -= 1;
    setredux();
  };

  const IncreamentVar = (data, ind) => {
    tempCampaign[index].variation[ind].quantity += 1;
    setredux();
  };

  const colorset = (data) => {
    tempCampaign[index].colors = col;
    setredux();
  };

  const colorsetVar = (ind) => {
    tempCampaign[index].variation[ind].colors = colVar;
    setredux();
  };

  const sizeset = (data) => {
    tempCampaign[index].size = size;
    setredux();
  };

  const sizesetVar = (ind) => {
    tempCampaign[index].variation[ind].size = sizeVar;
    setredux();
  };

  const setredux = () => {
    dispatch(
      campaignData({
        campaign: tempCampaign,
      })
    );
  };

  useEffect(() => {
    if (col) {
      colorset();
    }
  }, [col]);

  useEffect(() => {
    if (size) {
      sizeset();
    }
  }, [size]);

  useEffect(() => {
    if (sizeVar) {
      sizesetVar(sizedata);
    }
  }, [sizeVar]);

  useEffect(() => {
    if (colVar) {
      colorsetVar(coldata);
    }
  }, [colVar]);

  const variation = () => {
    campaign.map((obj) => {
      if (obj.id === data.id) {
        const indexToUpdate = campaign.findIndex(
          (variant) => variant.id === data.id
        );
        if (obj?.variation?.length) {
          const { size, colors, variation, ...rest } = obj;
          rest.quantity = 1;
          let temp = obj.variation;
          temp.push(rest);
        } else {
          const { size, colors, ...rest } = obj;
          rest.quantity = 1;
          const Updated = Object.assign(obj, { variation: [rest] });
          campaign.splice(indexToUpdate, 1, Updated);
        }
      }
    });
    setredux();
  };

  function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    url += "?" + new Date().getTime();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  useEffect(() => {
    selShirt(data);
  }, []);

  const selShirt = async (data) => {
    await toDataURL(data?.shirtDesignFront, async function (myBase64) {
      setshirtdata3(
        myBase64 &&
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          )
      );
    });
    await toDataURL(data?.shirtDesignBack, async function (myBase64) {
      setshirtdata4(
        myBase64 &&
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          )
      );
    });
  };
  // console.log("data==>", data);
  // console.log("color", data.hello.color);
  return (
    <>
      <tr BGCOLOR="#f5f5f5" style={{}}>
        <td style={{ width: "25%", paddindTop: "15px" }}>
          <td style={{ paddingLeft: "10px" }}>
            <img
              src={data.designShirt || data.designnimg}
              width={80}
              height={95}
              style={{
                position: "absolute",
                marginTop: "-18px",
                paddingBottom: "3px",
              }}
            />
          </td>
          <td
            style={{ paddingLeft: "15px", position: "absolute", left: "265px" }}
          >
            <p style={{ marginTop: "-5px" }}>
              <b>{data.shirtName || data.shirtname}</b>
            </p>
            <del>
              <p>
                <b>{data.sellingPrice}€</b>
              </p>
            </del>
            <p>
              <b>{data.realprice}€</b>
            </p>
          </td>
        </td>
        <td>
          <div style={{ paddingTop: "20px" }}>
            <SelectOpt
              option={
                data?.color
                  ? data.color
                  : data?.hello?.color
                  ? data.hello.color
                  : ""
              }
              onChange={(e) => {
                setcol(e.target.value);
                colorset();
              }}
              value={data?.colors ? data.colors : ""}
            />
          </div>
        </td>
        <td style={{ textAlign: "center" }}>
          <div style={{ marginLeft: "-120px", paddingTop: "20px" }}>
            <SelectOpt
              option={["S", "M", "L", "XL", "XXL"]}
              onChange={(e) => {
                setsize(e.target.value);
                sizeset();
              }}
              value={data?.size ? data.size : ""}
              size
            />
          </div>
        </td>
        <td className="quantity" style={{ paddingTop: "20px" }}>
          <td className="minus cp" colspan="3" onClick={() => Decreament(data)}>
            -
          </td>
          <td className="val">{data.quantity}</td>
          <td className="minus cp" colspan="3" onClick={() => Increament(data)}>
            +
          </td>
        </td>
        <td style={{ width: "120px", paddingTop: "20px" }}>
          {Number(data.quantity) * Number(data.realprice)}€
        </td>
        <td style={{ width: "120px", paddingTop: "20px" }}>
          <DeleteOutlineOutlinedIcon
            onClick={() => remove(data, index)}
            className="cp"
          />
        </td>
      </tr>

      {data?.variation?.length > 0 &&
        data.variation.map((variant, ind) => {
          return variant.quantity > 0 ? (
            <tr BGCOLOR="#f5f5f5" style={{}}>
              <td style={{ width: "25%" }}>
                <td style={{ paddingLeft: "10px" }}></td>
                <td style={{ paddingLeft: "15px" }}></td>
              </td>
              <td>
                <div style={{ paddingTop: "20px" }}>
                  <SelectOpt
                    option={
                      variant?.color
                        ? variant.color
                        : variant?.hello?.color
                        ? variant.hello.color
                        : ""
                    }
                    onChange={(e) => {
                      setcolVar(e.target.value);
                      colorsetVar(ind);
                      setcoldata(ind);
                    }}
                    value={variant?.colors ? variant.colors : ""}
                  />
                </div>
              </td>
              <td style={{ textAlign: "center" }}>
                <div style={{ marginLeft: "-120px", paddingTop: "20px" }}>
                  <SelectOpt
                    option={["S", "M", "L", "XL", "XXL"]}
                    onChange={(e) => {
                      setsizeVar(e.target.value);
                      sizesetVar(ind);
                      setsizedata(ind);
                    }}
                    value={variant?.size ? variant.size : ""}
                    size
                  />
                </div>
              </td>
              <td className="quantity" style={{ paddingTop: "20px" }}>
                <td
                  className="minus cp"
                  colspan="3"
                  onClick={() => DecreamentVar(variant, ind)}
                >
                  -
                </td>
                <td className="val">{variant.quantity}</td>
                <td
                  className="minus cp"
                  colspan="3"
                  onClick={() => IncreamentVar(variant, ind)}
                >
                  +
                </td>
              </td>
              <td style={{ width: "120px", paddingTop: "20px" }}>
                {Number(variant.quantity) * Number(variant.realprice)}€
              </td>
              <td style={{ width: "120px", paddingTop: "20px" }}>
                <DeleteOutlineOutlinedIcon
                  onClick={() => removeVar(index, ind)}
                  className="cp"
                />
              </td>
            </tr>
          ) : null;
        })}
      <tr BGCOLOR="#f5f5f5">
        <td></td>
        <td></td>
        <td>
          <div style={{ marginTop: "20px", marginLeft: 50 }}>
            <Button
              text={t("variation")}
              className="variationBtn"
              onClick={() => variation()}
            />
          </div>
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr BGCOLOR="#f5f5f5">
        <td>
          <hr />
        </td>
        <td>
          <hr />
        </td>
        <td>
          <hr />
        </td>
        <td>
          <hr />
        </td>
        <td>
          <hr />
        </td>
        <td>
          <hr />
        </td>
      </tr>
    </>
  );
};
export default OrderRow;
